<template>
  <div id="addCoupon" class="add-coupon">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toCouponList">优惠劵/</span>新增优惠券
      </template>
      <template v-slot:content>
        <section
          class="content base-info"
          :class="isShowCouponNameError && isShowCouponValueError ? '' : 'no-error'"
          ref="baseInfo"
        >
          <div class="desc">基础信息</div>
          <div class="column coupon-name-column">
            <div class="column-container">
              <div class="item-name">
                <svg class="icon">
                  <use xlink:href="#icon-必填" />
                </svg>
                <span class="name">优惠券名称：</span>
              </div>
              <el-input
                class="gray"
                type="text"
                maxlength="20"
                v-model="couponName"
                placeholder="请输入优惠券名称"
              ></el-input>
            </div>
            <div class="error" v-show="isShowCouponNameError">请输入优惠券名称</div>
          </div>
          <div class="column effective-time-column">
            <div class="item-name">
              <svg class="icon">
                <use xlink:href="#icon-必填" />
              </svg>
              <span class="name">有效时间：</span>
            </div>
            <div class="effective-time-type">
              <div class="type">
                <el-radio v-model="timeType" :label="timeTypes.rangeTime">{{emptyString}}</el-radio>
                <div class="range-time-container">
                  <el-date-picker
                    v-model="rangeStartTime"
                    type="date"
                    format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    value-format="timestamp"
                    placeholder="选择日期时间"
                  ></el-date-picker>至
                  <el-date-picker
                    v-model="rangeEndTime"
                    type="date"
                    format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    value-format="timestamp"
                    placeholder="选择日期时间"
                  ></el-date-picker>
                </div>
              </div>
              <div class="type">
                <el-radio v-model="timeType" :label="timeTypes.effectiveTime">{{emptyString}}</el-radio>
                <div class="effective-time-container">
                  领取后
                  <int-input
                    class="gray single-time-input"
                    :intNum="Number(effectiveTime)"
                    @complete="filterEffectiveTime"
                  ></int-input>天内有效
                </div>
              </div>
            </div>
          </div>
          <div class="column coupon-value-column">
            <div class="column-container">
              <div class="item-name">
                <svg class="icon">
                  <use xlink:href="#icon-必填" />
                </svg>
                <span class="name">优惠券面值：</span>
              </div>
              <el-input
                class="gray"
                @change="handleFaceValueChange"
                v-model="faceValue"
                placeholder="请输入优惠券面值"
              ></el-input>
            </div>
            <div class="error" v-show="isShowCouponValueError">请输入优惠券面值</div>
          </div>
          <div class="column use-condition-column">
            <div class="item-name">
              <svg class="icon">
                <use xlink:href="#icon-必填" />
              </svg>
              <span class="name">使用条件：</span>
            </div>
            <el-radio-group class="use-condition" v-model="useCondition">
              <el-radio :label="useConditionTypes.noLimit">无限制</el-radio>
              <el-radio :label="useConditionTypes.speciffiedLimit" class="el-radio-row">
                <div class="speciffied-limit-container">
                  满
                  <decimal-input
                    class="gray"
                    :decimalNum="Number(baseMoney)"
                    @complete="filterBaseMoney"
                  ></decimal-input>元可用
                </div>
              </el-radio>
            </el-radio-group>
          </div>
          <div class="column coupon-desc-column">
            <div class="item-name">
              <span class="name">使用说明：</span>
            </div>
            <el-input
              class="gray coupon-desc-textarea"
              v-model="couponDesc"
              type="textarea"
              placeholder="请输入优惠券说明"
              maxlength="100"
              show-word-limit
            ></el-input>
          </div>
        </section>
        <section class="content assign-setting">
          <div class="desc">发放设置</div>
          <div class="column">
            <div class="item-name">
              <svg class="icon">
                <use xlink:href="#icon-必填" />
              </svg>
              <span class="name">发放方式：</span>
            </div>
            <el-radio-group class="assign-type" v-model="assignType">
              <el-radio :label="assignTypes.proactiveAssign">主动领取</el-radio>
              <el-radio :label="assignTypes.directedAssign">定向发放</el-radio>
            </el-radio-group>
          </div>
          <div class="column-container" v-show="assignType === assignTypes.proactiveAssign">
            <div class="column">
              <div class="item-name">
                <svg class="icon">
                  <use xlink:href="#icon-必填" />
                </svg>
                <span class="name">总共发放：</span>
              </div>
              <div class="input-container">
                <int-input class="gray" :intNum="assignTotalNum" @complete="filterAssignTotalNum"></int-input>张
              </div>
            </div>
            <div class="column">
              <div class="item-name">
                <svg class="icon">
                  <use xlink:href="#icon-必填" />
                </svg>
                <span class="name">每人限领：</span>
              </div>
              <div class="input-container">
                <int-input class="gray" :intNum="limitNum" @complete="filterLimitNum"></int-input>张
              </div>
            </div>
          </div>
        </section>
        <section class="content coupon-use-range">
          <div class="desc">商品设置</div>
          <div class="column">
            <div class="item-name">
              <svg class="icon">
                <use xlink:href="#icon-必填" />
              </svg>
              <span class="name">商品范围：</span>
            </div>
            <el-radio-group class="use-range-type" v-model="useRangeType">
              <el-radio :label="useRangeTypes.allGood">全部商品</el-radio>
              <el-radio :label="useRangeTypes.speciffiedClassify">指定分类</el-radio>
              <el-radio :label="useRangeTypes.speciffiedGood">指定商品</el-radio>
            </el-radio-group>
          </div>
          <div
            class="add-container add-classify"
            v-show="useRangeType === useRangeTypes.speciffiedClassify"
          >
            <div class="tag-list">
              <el-tag
                class="tag"
                v-for="(tag, index) in selectedTagList"
                :key="index"
                closable
                @close="handleClose(tag)"
              >{{tag.label}}</el-tag>
            </div>
            <el-button class="btn-blue" @click="toAddClassify">添加分类</el-button>
          </div>
          <div
            class="add-container add-goods"
            v-show="useRangeType === useRangeTypes.speciffiedGood"
          >
            <!-- 指定商品 -->
            <div class="table selected-commodity-list">
              <el-table class="table-container" :data="showSelectedGoodList">
                <el-table-column label="商品名称" prop="name"></el-table-column>
                <el-table-column label="商品编码" prop="code"></el-table-column>
                <el-table-column label="零售价" prop="retailPrice"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="props">
                    <span class="column-btn" @click="removeCommodity(props.row)">删除</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination-tpl-container">
              <pagination-tpl
                :total="selectedGoodTotalNum"
                :currentPage="selectedGoodCurrPage"
                :pageSize="10"
                @queryChange="changeSelectedGood"
              ></pagination-tpl>
            </div>
            <el-button class="btn-blue" @click="toAddGood">添加商品</el-button>
          </div>
        </section>
        <!-- 新增分类 -->
        <div class="operations" ref="operations">
          <el-button class="btn-white" @click="toCancelCoupon">取消</el-button>
          <el-button class="btn-blue" @click="toSaveCoupon">保存</el-button>
        </div>
        <!-- 添加分类--弹框 -->
        <el-dialog class="add-classify-dialog" :visible.sync="isShowClassifyDialog" width="420px">
          <span class="dialog-title" slot="title">添加分类</span>
          <div class="dialog-content">
            <span class="content-desc">分类标签：</span>
            <el-select class="gray" v-model="selectedClassifyList" multiple placeholder="请选择分类">
              <el-option
                v-for="(item, index) in classifyList"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </div>
          <div class="dialog-footer" slot="footer">
            <el-button class="btn-white" @click="toCancelClassify">取消</el-button>
            <el-button class="btn-blue" @click="toSaveClassify">保存</el-button>
          </div>
        </el-dialog>
        <!-- 添加商品--弹框 -->
        <el-dialog class="add-good-dialog" :visible.sync="isShowGoodDialog" width="1200px">
          <span class="dialog-title" slot="title">添加商品</span>
          <div class="dialog-content">
            <div class="filter-good">
              <div class="good-classify">
                <el-cascader
                  v-model="selectedGoodClassify"
                  :options="goodClassifies"
                  :props="classifyProps"
                  placeholder="选择商品分类"
                  filterable
                  clearable
                ></el-cascader>
              </div>
              <div class="search-key">
                <el-input
                  class="gray"
                  placeholder="请输入商品名称"
                  @keyup.enter.native="filterGood"
                  v-model="searchKey"
                ></el-input>
              </div>
              <el-button class="btn-blue" @click="filterGood">筛选</el-button>
            </div>
            <div class="table-img">
              <el-table class="table-container commodity-list" :data="commodityList" height="260">
                <el-table-column width="60">
                  <template slot-scope="props">
                    <el-checkbox v-model="props.row.isSelected"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="商品主图">
                  <template slot-scope="props">
                    <div class="img-container">
                      <img class="good-img" width="40" height="40" :src="props.row.img" alt="商品图" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="商品名称">
                  <template slot-scope="props">
                    <p class="name">{{props.row.name}}</p>
                  </template>
                </el-table-column>
                <el-table-column label="商品分类" prop="classify"></el-table-column>
                <el-table-column label="市场价" prop="retailPrice"></el-table-column>
              </el-table>
            </div>
            <div class="pagination-tpl">
              <pagination-tpl :total="commodityTotal" @queryChange="searchCommodity"></pagination-tpl>
            </div>
          </div>
          <div class="dialog-footer" slot="footer">
            <el-button class="btn-white" @click="toCancelCommodity">取消</el-button>
            <el-button class="btn-blue" @click="toSaveCommodity">确定</el-button>
          </div>
        </el-dialog>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import IntInput from "components/base/IntInput";
import DecimalInput from "components/base/DecimalInput";
import DBCommodity from "models/db/commodity.js";
import DBCoupon from "models/db/coupon";
const dbCommodity = new DBCommodity();
const dbCoupon = new DBCoupon();
const timeTypes = {
  // 某个时间段
  rangeTime: 1,
  // 领取后几天内有效
  effectiveTime: 2
};
const useConditionTypes = {
  // 没有限制
  noLimit: 1,
  // 满XX元可以使用
  speciffiedLimit: 2
};
const assignTypes = {
  // 主动发放
  proactiveAssign: 1,
  // 定向发放
  directedAssign: 2
};
const useRangeTypes = {
  // 全部商品
  allGood: 1,
  // 指定分类
  speciffiedClassify: 2,
  // 指定商品
  speciffiedGood: 3
};
const INT_NUM_REG = /(^[1-9]+[0-9]*$)/;
export default {
  data() {
    const currTime = new Date().getTime();
    return {
      isShowCouponNameError: false,
      couponName: "",
      timeTypes: timeTypes,
      timeType: timeTypes.rangeTime,
      rangeStartTime: currTime,
      rangeEndTime: currTime,
      effectiveTime: 1,
      isShowCouponValueError: false,
      faceValue: "",
      useConditionTypes: useConditionTypes,
      useCondition: useConditionTypes.noLimit,
      baseMoney: "",
      // 使用声明
      couponDesc: "",
      assignTypes: assignTypes,
      assignType: assignTypes.proactiveAssign,
      // 主动发放--共发
      assignTotalNum: 1,
      // 主动发放--每人限领
      limitNum: 1,
      useRangeTypes: useRangeTypes,
      useRangeType: useRangeTypes.allGood,
      // 空字符占位
      emptyString: "",
      // 显示添加分类弹框
      isShowClassifyDialog: false,
      classifyList: [],
      selectedClassifyList: [],
      // 展示的标签列表
      selectedTagList: [],
      // 显示添加商品弹框
      isShowGoodDialog: false,
      // 已选的商品分类
      selectedGoodClassify: [null, null, null],
      // 商品分类
      goodClassifies: [],
      classifyProps: {
        value: "id",
        label: "cateName",
        children: "children"
      },
      // 商品查询关键字
      searchKey: "",
      // 商品列表当前所在页
      currentPage: 1,
      // 商品总条数
      commodityTotal: 1,
      // 商品列表
      commodityList: [],
      // 已经被选中的商品列表--只存id
      selectedCommodityList: [],
      // 临时被选择的商品列表--只存id
      tmpSelectedCommodityList: [],
      // 已选商品列表分页
      selectedGoodCurrPage: 1,
      // 弹框商品列表
      searchWithNoParam: true,
      // 商品查询参数列表
      options: {
        category1Id: "",
        goodsName: ""
      },
      //设置当前时间前不可选
      pickerOptions: {
        // 限制日期
        disabledDate: this.disabledDate
      },
    };
  },
  computed: {
    showSelectedGoodList() {
      let startIndex = (this.selectedGoodCurrPage - 1) * 10;
      let endIndex = this.selectedGoodCurrPage * 10;
      return this.selectedCommodityList.slice(startIndex, endIndex);
    },
    selectedGoodTotalNum() {
      return this.selectedCommodityList.length;
    }
  },
  watch: {
    commodityList: {
      deep: true,
      handler(newVal, oldVal) {
        // 如果被选中要将元素放入tmpSelectedCommodityList，反之要剔除
        newVal.map(item => {
          // 先判断item在不在tmpSelectedCommodityList列表
          let isHave = this.tmpSelectedCommodityList.find(
            oldCommodity => oldCommodity.id === item.id
          );
          if (item.isSelected) {
            if (!isHave) {
              // 添加
              this.tmpSelectedCommodityList.push(item);
            }
          } else {
            if (isHave) {
              // 剔除
              let index = this.tmpSelectedCommodityList.findIndex(
                editedCommodityId => editedCommodityId.id === item.id
              );
              this.tmpSelectedCommodityList.splice(index, 1);
            }
          }
        });
      }
    }
  },
  methods: {
    disabledDate(date) {
      //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
      return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
    },
    handleClose(tag) {
      this.selectedTagList.splice(this.selectedTagList.indexOf(tag), 1);
      this.selectedClassifyList = [];
      this.selectedTagList.map(item => {
        this.selectedClassifyList.push(item.value);
      });
    },
    // 已选择商品列表的本地分页
    changeSelectedGood(options) {
      this.selectedGoodCurrPage = options.currentPage;
    },
    handleFaceValueChange(val) {
      let isEffectiveNum = INT_NUM_REG.test(Number(val));
      isEffectiveNum ? (val = INT_NUM_REG.exec(val).shift() || 1) : (val = 1);
      this.faceValue = val;
    },
    filterEffectiveTime(value) {
      this.effectiveTime = Number(value);
    },
    filterFaceValue(value) {
      this.faceValue = Number(value);
    },
    filterBaseMoney(value) {
      this.baseMoney = Number(value);
    },
    filterAssignTotalNum(value) {
      this.assignTotalNum = Number(value);
    },
    filterLimitNum(value) {
      this.limitNum = Number(value);
    },
    toCouponList() {
      this.$router.push({
        path: "/admin/marketing/coupon/coupon-list"
      });
    },
    toCancelClassify() {
      this._hideClassifyDialog();
    },
    toSaveClassify() {
      this.selectedTagList = [];
      this.selectedClassifyList.map(id => {
        let tag = this.classifyList.find(item => item.value === id);
        this.selectedTagList.push(tag);
      });
      this._hideClassifyDialog();
    },
    toCancelCommodity() {
      this._resetCommodityListToUnselected();
      this._hideGoodDialog();
    },
    toSaveCommodity() {
      let tmpSelected = [];
      let selected = [];
      this.tmpSelectedCommodityList.map(item => {
        tmpSelected.push(JSON.stringify(item));
      });
      this.selectedCommodityList.map(item => {
        selected.push(JSON.stringify(item));
      });
      let noRepeat = Array.from(new Set(selected.concat(tmpSelected)));
      this.selectedCommodityList = [];
      noRepeat.map(item => {
        this.selectedCommodityList.push(JSON.parse(item));
      });
      this.tmpSelectedCommodityList = [];
      this._resetCommodityListToUnselected();
      this._hideGoodDialog();
    },
    removeCommodity(good) {
      let tragetIndex = this.selectedCommodityList.findIndex(
        item => item.id === good.id
      );
      this.selectedCommodityList.splice(tragetIndex, 1);
    },
    toAddClassify() {
      this._showClassifyDialog();
    },
    toAddGood() {
      this._showGoodDialog();
    },
    toCancelCoupon() {
      this.toCouponList();
    },
    toSaveCoupon() {
      if (!this.couponName) {
        this.isShowCouponNameError = true;
        return false;
      } else {
        this.isShowCouponNameError = false;
      }
      if (!this.faceValue) {
        this.isShowCouponValueError = true;
        return false;
      } else {
        this.isShowCouponValueError = false;
      }
      let goodsIds = [];
      this.selectedCommodityList.map(item => {
        goodsIds.push(item.id);
      });
      let data = {
        title: this.couponName,
        timeType: this.timeType,
        beginTime: this.rangeStartTime,
        endTime: this.rangeEndTime,
        effectiveTime: this.effectiveTime,
        faceValue: this.faceValue,
        useCondition: this.useCondition,
        baseMoney: this.baseMoney,
        instruction: this.couponDesc,
        issuanceMethod: this.assignType,
        num: this.assignTotalNum,
        receivedLimit: this.limitNum,
        goodsLimit: this.useRangeType,
        categoryIds: this.selectedClassifyList,
        goodsIds: goodsIds
      };
      this._addCoupon(data);
    },
    filterGood() {
      this.searchWithNoParam = false;
      this.currentPage = 1;
      let category1Id = "";
      category1Id = this.selectedGoodClassify[2]
        ? this.selectedGoodClassify[2]
        : this.selectedGoodClassify[1]
        ? this.selectedGoodClassify[1]
        : "";
      this.options = Object.assign(this.options, {
        currentPage: this.currentPage,
        category1Id: category1Id,
        goodsName: this.searchKey
      });
      this._getCommodityList(this.options);
    },
    searchCommodity(query) {
      console.log("翻页查询", query);
      if (this.searchWithNoParam) {
        this._getCommodityList(query);
      } else {
        this.options = Object.assign(this.options, query);
        this._getCommodityList(this.options);
      }
    },
    // 点取消商品编辑时重置所有被选择的商品
    _resetCommodityListToUnselected() {
      this.commodityList.map(item => {
        item.isSelected = false;
      });
    },
    _getClassifyList() {
      dbCommodity
        .getDBGoodsClassify({
          parentId: 0
        })
        .then(res => {
          if (res.success) {
            res.result.map(item => {
              this.classifyList.push({
                value: item.id,
                label: item.cateName
              });
            });
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000
            });
          }
        });
    },
    _getDBGoodsClassify() {
      dbCommodity.getDBGoodsClassify().then(res => {
        if (res.success) {
          this.goodClassifies = res.result;
        }
      });
    },
    _getCommodityList(options) {
      // dbCommodity.getGeneralGoodsList(options).then(res => {
      dbCommodity.getAddGeneralGoodsList(options).then(res => {
        if (res.success) {
          let { totalNum, items } = res.result;
          this.commodityTotal = totalNum;
          this.commodityList = [];
          items.map(commodity => {
            this.commodityList.push({
              isSelected: false,
              id: commodity.id,
              code: commodity.code,
              img: commodity.itemImages[0],
              name: commodity.goodsName,
              classify: commodity.categoryName,
              retailPrice: commodity.defaultPrice
            });
          });
          // 重置状态
          this.tmpSelectedCommodityList.map(selectedItem => {
            let selectedCommodityId = selectedItem.id;
            this.commodityList.map(item => {
              if (item.id === selectedCommodityId) {
                // 说明这个之前被选中
                item.isSelected = true;
              }
            });
          });
        }
      });
    },
    _hideClassifyDialog() {
      this.isShowClassifyDialog = false;
    },
    _addCoupon(data) {
      dbCoupon.addCoupon(data).then(res => {
        if (res.success) {
          this.$message({
            message: "新增成功",
            center: true,
            type: "success",
            duration: 1000
          });
          this.$router.push({
            name: "coupon-list",
            params: {
              change: true
            }
          });
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000
          });
        }
      });
    },
    _showClassifyDialog() {
      this.isShowClassifyDialog = true;
    },
    _hideGoodDialog() {
      this.isShowGoodDialog = false;
    },
    _showGoodDialog() {
      this.isShowGoodDialog = true;
    }
  },
  created() {
    // 一级分类
    this._getClassifyList();
    this._getDBGoodsClassify();
    this._getCommodityList({
      currentPage: 1
    });
  },
  mounted() {
    const paddingWidth = 46;
    this.$refs.operations.style.width =
      this.$refs.baseInfo.clientWidth + paddingWidth + "px";
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.baseInfo.clientWidth + paddingWidth + "px";
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
    IntInput,
    DecimalInput
  }
};
</script>

<style lang="scss" scoped>
.add-coupon {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: rgba(96, 98, 102, 1);
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .content {
    box-sizing: border-box;
    padding-bottom: 60px;
    .desc {
      box-sizing: border-box;
      width: 100%;
      height: 32px;
      padding-left: 4px;
      line-height: 32px;
      margin-bottom: 20px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px 4px 0px 0px;
    }
    .column {
      display: flex;
      margin-bottom: 20px;
      .item-name {
        box-sizing: border-box;
        width: 120px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .icon {
          width: 12px;
          height: 12px;
        }
      }
      .use-condition {
        display: flex;
        flex-direction: column;
        .el-radio-row {
          margin-top: 16px;
          display: flex;
          align-items: center;
          .speciffied-limit-container {
            display: flex;
            justify-content: center;
            align-items: center;
            .gray {
              width: 80px;
            }
          }
        }
      }
      .gray {
        width: 320px;
      }
      .limit-value-input,
      .single-time-input {
        width: 80px;
      }
    }
    .effective-time-column,
    .coupon-desc-column {
      .item-name {
        padding-top: 10px;
        align-items: flex-start;
      }
      .effective-time-type {
        .type {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .effective-time-container {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          &:first-child {
            margin-bottom: 20px;
          }
          .el-radio {
            margin-right: 0px;
          }
        }
      }
    }
    .use-condition-column {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .add-container {
      width: 560px;
      min-height: 100px;
      border: 1px solid rgba(238, 238, 238, 1);
      margin-left: 120px;
      padding: 20px 20px 38px 20px;
      .tag-list {
        .tag {
          margin-right: 6px;
          margin-bottom: 6px;
        }
      }
      .selected-commodity-list {
        .column-btn {
          font-size: 12px;
          color: #3d74f2;
          cursor: pointer;
        }
      }
      .btn-blue {
        margin-top: 10px;
        margin-left: 10px;
      }
    }
  }
  .base-info {
    .coupon-name-column,
    .coupon-value-column {
      margin-bottom: 0px;
      display: flex;
      flex-direction: column;
      .column-container {
        display: flex;
      }
      .error {
        padding-left: 120px;
        color: red;
        font-size: 12px;
        margin-top: 2px;
        margin-bottom: 20px;
      }
    }
  }
  .base-info.no-error {
    .coupon-name-column,
    .coupon-value-column {
      margin-bottom: 20px;
    }
  }
  .assign-setting {
    .column-container {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .column {
        margin-right: 40px;
        .input-container {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .gray {
            width: 60px;
            margin-right: 10px;
          }
        }
      }
    }
  }
  .operations {
    height: 60px;
    position: fixed;
    left: 256px;
    bottom: 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    .btn-white {
      margin-right: 20px;
    }
  }
  .add-classify-dialog {
    .dialog-title {
      width: 100%;
      display: inline-block;
      margin-bottom: 16px;
      border-bottom: 1px solid #eeeeee;
    }
    .dialog-content {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .gray {
        flex: 1;
      }
      .pagination-tpl {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: center;
      align-items: center;
      .btn-white {
        margin-right: 24px;
      }
    }
  }
  .add-good-dialog {
    .dialog-title {
      width: 100%;
      display: inline-block;
      margin-bottom: 16px;
      border-bottom: 1px solid #eeeeee;
    }
    .dialog-content {
      .filter-good {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 16px;
        .good-classify {
          margin-right: 16px;
        }
        .search-key {
          .gray {
            width: 260px;
          }
        }
        .btn-blue {
          margin-left: 20px;
          width: 80px;
        }
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: center;
      align-items: center;
      .btn-white {
        margin-right: 24px;
      }
    }
  }
}
</style>

<style lang="scss">
#addCoupon {
  .table {
    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          tr {
            th {
              .cell {
                font-size: 12px;
              }
            }
          }
        }
      }
      .el-table__body-wrapper {
        .el-table__body {
          tr {
            td {
              .cell {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
